import React, { Component, Fragment } from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, YAxis, XAxis, Tooltip, Legend, Bar } from 'recharts';
import { Card, CardHeader } from 'material-ui';

class StackedBarChart extends Component {
    _renderTooltip(props, barKeys, colors) {
        const { active, payload } = props;
        if (!active) return null;
        let data = payload[0].payload;
        return (
            <div className="custom-tooltip">
                <p className="label" style={{
                    fontWeight: 700
                }}>{`${props.label}`}</p>
                {barKeys.map((bar, index) => {
                    if (data[bar.key]) {
                        return (
                            <p key={`${data.field}_${bar.key}`} style={{ color: colors[index] }} className="label"><b>{bar.label}:</b> {data[bar.key]}</p>
                        );
                    }
                    return null;
                })}
            </div>
        );
    }

    _renderLegend(props, barKeys, colors) {
        return (
            <ul style={{
                margin: 0,
                padding: 0,
                display: "flex",
                justifyContent: "center",
                listStyle: "none"
            }}>
                {
                    barKeys.map((bar, index) => (
                        <li style={{ color: colors[index], marginLeft: "1.2rem" }} key={`item-${index}`} className="recharts-legend-item">
                            <svg width={14} height={14} style={{ marginRight: "0.2rem" }}>
                                <rect width={14} height={14} rx={2} ry={2} style={{ fill: colors[index] }} />
                            </svg>
                            <b>{bar.label}</b>
                        </li>
                    ))
                }
            </ul>
        );
    }

    render() {
        const { data, vertical, dataKeyX, dataKeyY, colors, barKeys } = this.props;
        return (
            <Fragment>
                {data.length > 0 ?
                    <ResponsiveContainer minHeight={580} id="graphic">
                        <BarChart layout={vertical} data={data}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <YAxis type={vertical ? "category" : "number"} width={window.innerWidth * 0.7 * 0.2} dataKey={vertical ? dataKeyY : dataKeyX} />
                            <XAxis type={vertical ? "number" : "category"} dataKey={!vertical ? dataKeyY : dataKeyX} />
                            <Tooltip content={(props) => this._renderTooltip(props, barKeys, colors)} />
                            <Legend content={(props) => this._renderLegend(props, barKeys, colors)} />
                            {barKeys.map((bar, index) => {
                                return (
                                    <Bar key={bar.key} stackId={bar.key} dataKey={bar.key} fill={colors[index]} />
                                );
                            })}
                        </BarChart>
                    </ResponsiveContainer>
                    :
                    <Card style={{ textAlign: "center" }}>
                        <CardHeader title="Non hay resultados" />
                    </Card>
                }
            </Fragment>
        );
    }
}

export default StackedBarChart;



// WEBPACK FOOTER //
// ./src/components/chartComponents/StackedBarChart.js